import { SelectOption } from 'v2/types';
import { TournamentModel } from 'v2/types/TournamentModel';

export function tournamentsToOptions(tournaments: TournamentModel[]): SelectOption[] {
  return tournaments.map((tournament) => ({ id: tournament.id, value: tournament.id, label: tournament.name }));
}
